import { EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import * as React from 'react';

import { getPhoneLink } from './getPhoneLink';
import { requestDynamicPhone } from './requestDynamicPhone';
import { useApplicationContext } from '../../utils/applicationContext';
import { parsePhoneNumber } from '../../utils/strings';

interface IUseRevealDynamicPhoneParams {
  entityId: number;
  phone?: string | null;
  siteBlockId?: number | null;
}

interface IUseRevealDynamicPhoneResult {
  revealedPhone: string | null;
  isLoading: boolean;
  reveal(): Promise<void>;
}

function formatPhone(phone: string | null | undefined): string | null {
  const normalized = getPhoneLink(phone);

  return normalized ? parsePhoneNumber(normalized.slice(1)) : null;
}

export function useRevealDynamicPhone({
  entityId,
  phone,
  siteBlockId,
}: IUseRevealDynamicPhoneParams): IUseRevealDynamicPhoneResult {
  const { httpApi, logger } = useApplicationContext();
  const [revealedPhone, setRevealedPhone] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const reveal = React.useCallback(async () => {
    setIsLoading(true);

    try {
      const dynamicPhone = await requestDynamicPhone({
        httpApi,
        logger,
        entityId,
        siteBlockId,
        platformType: EPlatformTypes.WebDesktop,
      });

      setRevealedPhone(formatPhone(dynamicPhone) || formatPhone(phone));
    } finally {
      setIsLoading(false);
    }
  }, [entityId, httpApi, logger, phone, siteBlockId]);

  return { revealedPhone, isLoading, reveal };
}
